export default () => (dispatch, getState) => {
  const { app: { html: { dir } } } = getState();
  if(dir === 'bottom'){
    dispatch({ type: "APP/HTML/LEFT" });
  }else{
    dispatch({ type: "APP/HTML/BOTTOM" });
  }
};
